import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { NameTranslationType, Size } from "app/models/menu.model";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

export interface ManualSizeCreateDto {
  organizationId: string;
  productExternalId: string;
  name: string;
  nameTranslations: NameTranslationType;
  price: number;
  weight: number;
  isHidden: boolean;
  externalPictureUrl?: string;
  linkedProductExternalId?: string;
}

export interface ManualSizeUpdateDto {
  name: string;
  nameTranslations: NameTranslationType;
  price: number;
  weight: number;
  isHidden: boolean;
  externalPictureUrl?: string;
  linkedProductExternalId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SizeService {

  private requestPath = `${environment.posBaseUrl}/api/front/size`;

  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private http: HttpClient,
  ) { }

  public createSize(size: ManualSizeCreateDto): Observable<Size> {
    return this.http.post<Size>(
      this.requestPath,
      size,
      {
        headers: this.headers,
      });
  }

  public updateSize(sizeId: string, size: ManualSizeUpdateDto): Observable<Size> {
    return this.http.put<Size>(
      `${this.requestPath}/${sizeId}`,
      size,
      {
        headers: this.headers,
      });
  }

  public deleteSize(sizeId: string): Observable<any> {
    return this.http.delete(`${this.requestPath}/${sizeId}`);
  }
}
